import { Moonriver } from "@usedapp/core";

export function useCurrentNetworkId() {
  return Moonriver.chainId;
}
